// CORE-1735 slice 17 (D-120, QA V06) — Live icon «camera» from the published set v4.2
// (Confluence 110461314, archive reference-icons-v4.2): geometry as shipped, strokes 1.8,
// paint from the caller (`color` — solid or an ink gradient reference), the inner
// highlight through `filter` (the toolbar's «live-polish»), the slash cut by `cut`.
import React from 'react';
import Svg, { G, Path, Rect } from 'react-native-svg';
import type { LiveGlyphProps } from '../types';

export const Camera: React.FC<LiveGlyphProps> = ({ size, color, filter }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <G filter={filter} fill={color} fillRule="evenodd">
    <Rect x={2} y={5} width={14} height={14} rx={3.4} fill={color} />
    <Path d="M17 9.4l4.7-3a.8.8 0 0 1 1.3.7v9.8a.8.8 0 0 1-1.3.7l-4.7-3Z" fill={color} />
    </G>
  </Svg>
);
